export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://www.southasiaconsultancy.com";

export const OG_IMAGE_PATH = "/og-image.png";

export const DEFAULT_DESCRIPTION =
  "South Asia Consultancy (SAC) delivers integrated oilfield services, drilling, workover, operations & maintenance and manpower solutions across global energy markets.";

export const PAGE_SEO = {
  "/": {
    title: null,
    description: DEFAULT_DESCRIPTION,
  },
  "/about": {
    title: "About",
    description:
      "Learn about South Asia Consultancy — our leadership, vision, global presence, and integrated energy services across offshore and onshore operations.",
  },
  "/major-milestone": {
    title: "Major Milestones",
    description:
      "Explore South Asia Consultancy’s major milestones, including the South Patan Oil & Gas Block award and our journey as an operator-driven energy partner.",
  },
  "/services": {
    title: "Services",
    description:
      "Explore SAC integrated oilfield services: drilling, workover & completion, operations & maintenance, oilfield equipment, and manpower supply.",
  },
  "/services/drilling": {
    title: "Drilling Services",
    description:
      "Professional drilling support services for onshore and offshore energy operations — capabilities, technology, and project experience.",
  },
  "/services/workover-completion": {
    title: "Workover & Well Intervention Services",
    description:
      "Workover and well intervention services for oil and gas wells — rehabilitation, production enhancement, and operational excellence from SAC.",
  },
  "/services/oam": {
    title: "Operations & Maintenance",
    description:
      "Oilfield operations and maintenance services for energy assets — coverage, capabilities, and proven project delivery.",
  },
  "/services/equipment": {
    title: "Oilfield Equipment",
    description:
      "Oilfield equipment services including generator fleets, compressors, and specialized equipment for energy projects worldwide.",
  },
  "/services/manpower": {
    title: "Manpower Supply",
    description:
      "Global energy workforce and manpower supply solutions — recruitment, deployment, shutdown specialists, and crew management.",
  },
  "/projects": {
    title: "Projects",
    description:
      "SAC project portfolio across drilling, workover, O&M, and workforce deployment in India and international energy markets.",
  },
  "/equipment": {
    title: "Equipment",
    description:
      "South Asia Consultancy equipment capabilities, categories, and global deployment for oilfield operations.",
  },
  "/clients": {
    title: "Clients",
    description:
      "Trusted by leading energy companies. Explore SAC client partnerships and industry coverage across the oil and gas sector.",
  },
  "/careers": {
    title: "Careers",
    description:
      "Join South Asia Consultancy. Explore careers in drilling, workover, maintenance, HSE, and energy operations across global projects.",
  },
  "/awards-and-recognitions": {
    title: "Awards and Recognitions",
    description:
      "SAC awards, certifications, accreditations, compliance standards, and performance excellence in oilfield services.",
  },
  "/contacts": {
    title: "Contacts",
    description:
      "Contact South Asia Consultancy — Ahmedabad, Mumbai, and Sharjah offices. Discuss your oilfield and workforce requirements.",
  },
  "/media": {
    title: "Media",
    description:
      "News, insights, and updates from South Asia Consultancy on energy operations, workforce, and industry trends.",
  },
  "/media/blogs": {
    title: "Blogs",
    description:
      "Industry blogs and technical insights from South Asia Consultancy on oilfield services and energy workforce.",
  },
  "/media/news": {
    title: "News",
    description:
      "Latest news and announcements from South Asia Consultancy in oilfield services and energy operations.",
  },
  "/gallery": {
    title: "Gallery",
    description:
      "Photo gallery showcasing South Asia Consultancy projects, operations, and team across energy markets.",
  },
  "/privacy-policy": {
    title: "Privacy Policy",
    description:
      "South Asia Consultancy privacy policy — how we collect, use, and protect your personal information.",
  },
  "/terms-of-use": {
    title: "Terms of Use",
    description:
      "Terms of use for the South Asia Consultancy website and digital services.",
  },
  "/cookie-policy": {
    title: "Cookie Policy",
    description:
      "Information about cookies used on the South Asia Consultancy website and how to manage your preferences.",
  },
};

export function getSeoForPath(pathname) {
  return PAGE_SEO[pathname] || {
    title: "Page Not Found",
    description: DEFAULT_DESCRIPTION,
    noIndex: true,
  };
}
